export default {"src":"/_next/static/media/cointelegraph.b311b6bb.svg","height":74,"width":182,"blurWidth":0,"blurHeight":0};